import { withInstall } from '../../utils/install';
import Cascader from './index.vue';

export const IvueCascader = withInstall(Cascader);
export default IvueCascader;

export * from './index.vue';
